import {GIH_FAILURE, GIH_PENDING, GIH_SUCCESS} from './constants'

const initialState = {
  itemHistory: null,
  error: null,
  isLoading: false,
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GIH_PENDING:
      return {
        ...state,
        isLoading: true,
        error: null,
      }
    case GIH_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        itemHistory: action.payload,
      }
    case GIH_FAILURE:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      }
    default:
      return state
  }
}

export default reducer
